// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Gr_Q","left":"styles_left__35bKW"};